import { PreRecruitingInterviewIllustration } from '../../../../../assets/illustrations';
import { RecruitingInterviewDetail } from '../../../../../store/exam/types';
import { ArrowRightIcon, WarningIcon } from '../../../../../assets/icons/common';
import { setExamRulesModal } from '../../../../../store/exam/slice';
import { useDispatch } from '../../../../../store/store';
import Spinner from '../../../../../components/Spinner';
import Button from '../../../../../components/Button';
import { MediaPermission } from '../../types';
import styles from './style.module.scss';

interface Props {
    action?: string;
    loading: boolean;
    onStart: () => void;
    onEnableMedia: () => void;
    mediaPermission: MediaPermission;
    detail: RecruitingInterviewDetail | null;
};

/** Entrance screen: what the interview involves and the button that starts it. */
function PreInterview(props: Props) {
    const {
        detail,
        action,
        loading,
        onStart,
        onEnableMedia,
        mediaPermission,
    } = props;

    const dispatch = useDispatch();

    return (
        <div className={styles.container}>
            <div className={styles.detail}>
                <PreRecruitingInterviewIllustration />
                <span className={styles.detail_title}>Press the start button when you're ready</span>
                {!detail ? <Spinner /> : <ul>
                    <li>Your video will be recorded during the interview.</li>
                    <li>
                        There are <b>{detail.countQuestions}</b> questions
                        to answer, with total <b>{detail.time}</b> minutes.
                    </li>
                </ul>}
                {mediaPermission === 'denied' && (
                    <div className={styles.warning}>
                        <div className={styles.warning_description}>
                            <WarningIcon />
                            <span>Before the exam begins, you must give permission to camera and microphone record the session.</span>
                        </div>
                        <span className={styles.warning_link} onClick={onEnableMedia}>Enable camera record</span>
                    </div>)}
                <Button
                    type='Primary'
                    onClick={onStart}
                    loading={loading}
                    className={styles.CTA}
                    disabled={!detail || mediaPermission !== 'granted'}
                    text={`${action === 'resume' ? 'Continue' : 'Start'} recruiting interview`}
                />
                <div className={styles.extra}>
                    <span className={styles.extra_text}>
                        Please review interview rules before starting
                    </span>
                    <div
                        className={styles.extra_btn}
                        onClick={() => dispatch(setExamRulesModal(true))}
                    >
                        <span>Exams rules</span>
                        <ArrowRightIcon />
                    </div>
                </div>
            </div>
        </div>
    )
};

export default PreInterview;
